export enum LinkedCollectionStorageType {
	None = 0,
	Relational = 1,
	Historical = 2
}